export const getAuthHeader = (): Record<string, string> => {
    const credentials = localStorage.getItem('admin_credentials');
    return credentials ? { 'Authorization': `Basic ${credentials}` } : {};
};

export const setCredentials = (username: string, password: string) => {
    const encoded = btoa(`${username}:${password}`);
    localStorage.setItem('admin_credentials', encoded);
};

export const clearCredentials = () => {
    localStorage.removeItem('admin_credentials');
};

export const isAuthenticated = () => {
    return !!localStorage.getItem('admin_credentials');
};
